import React from 'react';
import { shape, string } from 'prop-types';
import { AppWrappperHOC } from '../Root/HOC';
import StyledPaymentStatus from './StyledPaymentStatus';
import { PAYMENT_STATUS_CONTENT } from './constant';

const LyraPaymentsStatus = (props) => {
  const {
    match: { params: { status = 'processing' } = {} },
  } = props;

  const statusData = PAYMENT_STATUS_CONTENT[status];
  const { image, title, subtitle } = statusData;

  return (
    <StyledPaymentStatus>
      <img
        src={image}
        alt={title}
        className={`payment-status-img ${status === 'processing' ? 'large' : ''}`}
      />
      <div className="payment-status-title">{title}</div>
      <div className="payment-status-subtitle">{subtitle}</div>
    </StyledPaymentStatus>
  );
};

LyraPaymentsStatus.propTypes = {
  match: shape({
    params: shape({
      status: string,
    }),
  }).isRequired,
};

const component = AppWrappperHOC(LyraPaymentsStatus);
export { LyraPaymentsStatus };
export default component;



// WEBPACK FOOTER //
// client/containers/LyraPaymentStatus/index.js